import Box from '@mui/material/Box';
import pxToRem from 'assets/theme/function/px-to-rem';
import * as React from 'react';
import { AppBar, SvgIcon } from '@mui/material';
import ProjectLogo from 'component/project-logo';
import AccountMenu from 'component/account-menu';
import { useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
    const navigate = useNavigate();
    return (
        <AppBar position="static" sx={{ height: pxToRem(90) }}>
            <Box
                height="100%"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Box
                    ml={pxToRem(10)}
                    onClick={() => navigate(`cards-sphere/sphere`)}
                >
                    <SvgIcon
                        component={ProjectLogo}
                        inheritViewBox
                        sx={{
                            fontSize: {
                                xs: pxToRem(37),
                                md: pxToRem(48),
                            },
                        }}
                    />
                </Box>
                <AccountMenu />
            </Box>
        </AppBar>
    );
};
export default Header;
